<template>
  <v-list class="py-0">
    <template v-for="item in getItems">
      <v-list-group no-action :key="item.id"
        append-icon="fal fa-angle-down"
        :class="['px-0', { 'red lighten-4': item.status === 'locked' }]">
        <template v-slot:activator>
          <v-list-item-content class="py-0">
            <v-row>
              <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.date }}</v-col>
              <v-col :class="['text-right text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.withdraw }}</v-col>
              <v-col :class="['text-right text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.deposite }}</v-col>
              <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ item.client }}</v-col>
              <v-col :class="['text-center text-truncate', { caption: $vuetify.breakpoint.mdAndDown }]">{{ `${item.item}: ${item.children.length}` }}</v-col>
            </v-row>
          </v-list-item-content>
        </template>
        <v-list-item v-for="jtem in item.children" :key="jtem.id">
          <v-list-item-avatar>
            <v-icon small>{{ jtem.cbook.flag === 'T' ? 'fa-lock' : 'fa-check' }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-content class="py-0">
            <v-list-item-subtitle>{{ `${jtem.client}：${jtem.cbook.title}：${$props.meta.type[jtem.type] || ''}：${$props.meta.items[jtem.label] || ''}` }}</v-list-item-subtitle>
            <v-list-item-title>{{ jtem.sum }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-divider :key="`${item.id}_div`"></v-divider>
    </template>
    <v-list-item v-if="getItems.length === 0">
      <v-list-item-content>
        <v-list-item-title class="text-center">登録されている項目はありません</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'authorBbookRemoveMitsuisumitomo',
  props: [ 'items', 'meta' ],
  data () {
    return {
    }
  },
  computed: {
    getItems () {
      return (this.$props.items && this.$props.items.length) ? this.$props.items.map(it => {
        return {
          id: it.id,
          date: this.$moment(it.date).format('YYYY/MM/DD'),
          withdraw: `${it.withdraw}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
          deposite: `${it.deposite}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
          client: it.client,
          item: it.label,
          status: it.status,
          children: it.children
        }
      }) : []
    }
  }
}
</script>